import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { EditContactService } from '../../../../../../_services/edit-contact.service';
import { AcmicService, AlertService } from '@mapfre-design-library/src/public_api';
import { Router , RouterModule } from '@angular/router';
import { PolicyDetailsService } from '../../../../../../_services/my-insurance/policy-details.service';
import { ErrorRedirectionService } from '../../../../../../_services/error-service/error-redirection.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-change-policy-email',
  templateUrl: './change-policy-email.component.html',
})
export class ChangePolicyEmailComponent implements OnInit {
  @Input() policyId: string;
  @Input() userDetails;
  @Input() useAddnlClasses: string;
  loader = false;
  isAcmic = false;
  constructor(
    private editContactService: EditContactService,
    private alertService: AlertService,
    public router: Router,
    private policyDetailsService: PolicyDetailsService,
    private errorRedirectionService: ErrorRedirectionService,
    private acmicService: AcmicService
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
  }
  changePolicyEmail() {
    this.loader = true;
    this.editContactService
      .editContactDetailsOnAdd(
        this.userDetails.email.address,
        this.buildContactObj()
      )
      .subscribe(() => {
        this.addPolicyToEmail();
      });
  }
  addPolicyToEmail() {
    this.policyDetailsService
      .addPolicyToEmail(this.userDetails.email.address, this.policyId)
      .subscribe(
        () => {
          this.loader = false;
          this.policyDetailsService
            .getPolicyDetailsByEmail(this.userDetails.email.address)
            .subscribe(() => {
              this.alertService.success('Policy added to your account.', true);
              this.router.navigate(['/my-insurance']);
            });
        },
        (error) => {
          this.loader = false;
          this.errorRedirectionService.errorRedirectHandler(error);
        }
      );
  }
  buildContactObj() {
    const contact = {
      contact: {
        nameInfo: {
          firstName: this.userDetails.firstName,
          middleName: '',
          lastName: this.userDetails.lastName,
        },
        policyNumbers: [this.policyId],
        emailList: [
          {
            emailAddress: this.userDetails.email.address,
            type: 'Primary',
          },
        ],
        phoneList: [],
      },
    };
    return contact;
  }
}
